import { useTranslation } from "react-i18next";
import fussFree from "@static/img/fuss_free.png";
import plasticFree from "@static/img/plastic_free.png";
import restrictionFree from "@static/img/restriction_free.png";
import { useState } from "react";
import { useStyle } from "./style";
import { Modal } from "@common/Modal/Modal";
import { Grid, Link, Typography } from "@mui/material";

export const MoreAboutEsim = () => {
    const { t } = useTranslation("eSim");

    const [isModalOpen, setIsModalOpen] = useState(false);

    const handleCloseModal = () => setIsModalOpen(false);
    const handleDisplayModal = () => setIsModalOpen(true);

    const { classes } = useStyle();

    return (
        <>
            <Link color="primary" component="button" underline="always" variant="normal" onClick={handleDisplayModal}>
                {t("aboutESim")}
            </Link>
            <Modal
                close={handleCloseModal}
                confirm={handleCloseModal}
                confirmLabel={t("closeESimModal")}
                isModalOpen={isModalOpen}
                title={t("aboutEsimTitle")}
            >
                <Typography className={classes.aboutESimItem}>{t("aboutEsimText")}</Typography>
                <Grid className={classes.aboutESimContent} container direction="row">
                    <Grid container direction="row" justifyContent="space-around">
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("plasticFreeTitle")} src={plasticFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("plasticFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("plasticFreeText")}</Typography>
                        </Grid>
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("fussFreeTitle")} src={fussFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("fussFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("fussFreeText")}</Typography>
                        </Grid>
                        <Grid className={classes.aboutESimItem} item md={3} xs={12}>
                            <img alt={t("restrictionFreeTitle")} src={restrictionFree} />
                            <Typography align="center" className={classes.aboutESimText} color="secondary" variant="h4">
                                {t("restrictionFreeTitle")}
                            </Typography>
                            <Typography className={classes.aboutESimText}>{t("restrictionFreeText")}</Typography>
                        </Grid>
                    </Grid>
                </Grid>
            </Modal>
        </>
    );
};
